import React from 'react';
import { Button } from '@mui/material';

export default function PatternButton({
  children,
  width,
  height,
  disabled = false,
  bgColor,
  ...props
}) {
  return (
    <Button
      disabled={disabled}
      variant="contained"
      color="tertiary"
      width={width}
      height={height}
      {...props}
    >
      {children}
    </Button>
  );
}
